const EVENT_TRACKING_NAME = 'MaitenanceDeleteModal';
const EVENT_TRACKING_ACTIONS = {
  confirmClicked: 'confirmClicked',
  cancelClicked: 'cancelClicked',
}

const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data },
  });
}
export default function MaintenancePlansDeleteModalController(
  $scope,
  $uibModalInstance,
  plan,
  $state,
  MaintenanceService,
  gettextCatalog
) {
  'ngInject';

  $scope.plan = plan;
  $scope.deleting = false;

  $scope.ok = function() {

    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.confirmClicked,
    });

    $scope.deleting = true;
    $scope.errorFlag = false;
    MaintenanceService.deletePlan($scope.plan).then(
      function(response) {
        $state.go('maintenance.plans');
      },
      function(error) {
        var errorMsg = gettextCatalog.getString('An error occurred while deleting the maintenance plan');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + error.status.toString();
          } else {
            errorMsg += ': ' + error.status.toString();
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.deleting = false;
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
      }
    );
  };

  $scope.cancel = function() {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.cancelClicked,
    });
    $uibModalInstance.close('cancel');
  };

  $scope.$on('$locationChangeStart', function(event, next, current) {
    $scope.cancel();
  });
}
